import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { Wishlist } from "@/builders/types/wishlist";

const list = function (params?: FilterParams) {
  return api.get<Wishlist>("wishlist", { params }).then(({ data }) => data);
};

export const wishlist = {
  list,
};
